
import axiosClient from '../axiosClient';

export const dailySalesApi = {
    getDailySalesData: async (year, month, filters = {}) => {
        try {
            const params = new URLSearchParams({ year, month });

            if (filters.customer) {
                filters.customer.split(',').forEach(v => { if (v.trim()) params.append('customer', v.trim()); });
            }
            if (filters.category) {
                filters.category.split(',').forEach(v => { if (v.trim()) params.append('category', v.trim()); });
            }
            if (filters.salesEmployee) {
                filters.salesEmployee.split(',').forEach(v => { if (v.trim()) params.append('salesEmployee', v.trim()); });
            }
            if (filters.contactPerson) {
                filters.contactPerson.split(',').forEach(v => { if (v.trim()) params.append('contactPerson', v.trim()); });
            }
            if (filters.itemCode) {
                filters.itemCode.split(',').forEach(v => { if (v.trim()) params.append('itemCode', v.trim()); });
            }

            console.log('📊 Fetching daily sales | Year:', year, 'Month:', month, 'Filters:', filters);
            const data = await axiosClient.get(`/daily-sales?${params.toString()}`);
            console.log('📊 Daily Sales API response:', data);
            return data;
        } catch (error) {
            console.error('Error fetching daily sales data:', error);
            throw error;
        }
    },

    getDailySalesDetail: async (year, month, day, filters = {}) => {
    try {
        const params = new URLSearchParams({ year, month, day });
        if (filters.customer)      filters.customer.split(',').forEach(v      => { if (v.trim()) params.append('customer',      v.trim()); });
        if (filters.category)      filters.category.split(',').forEach(v      => { if (v.trim()) params.append('category',      v.trim()); });
        if (filters.salesEmployee) filters.salesEmployee.split(',').forEach(v => { if (v.trim()) params.append('salesEmployee', v.trim()); });
        if (filters.contactPerson) filters.contactPerson.split(',').forEach(v => { if (v.trim()) params.append('contactPerson', v.trim()); });
        if (filters.itemCode)      filters.itemCode.split(',').forEach(v      => { if (v.trim()) params.append('itemCode',      v.trim()); });

        console.log('📋 getDailySalesDetail | date:', `${year}-${month}-${day}`, '| filters:', filters);
        const data = await axiosClient.get(`/daily-sales/detail?${params.toString()}`);
        return data;
    } catch (error) {
        console.error('Error fetching daily sales detail:', error);
        throw error;
    }
}
};